export default {
  reloadControllerConfig: 'Reload controller config',
};
